import { theme } from 'Assets/Styles/theme'

const style = {
  filtersWrapper: {
    display: 'flex',
    alignItems: 'end',
    '@media screen and (max-width: 768px)': {
      width: '100%',
      flexDirection: 'row',
      order: 2,
    },
  },
  removeMarginBottom: {
    marginBottom: '10px',
  },
  selectWrapper: {
    lineHeight: '40px',
    display: 'flex',
    flexDirection: 'column',
    marginRight: '10px',
    width: '234px',
    '& .select-field': {
      borderRadius: '8px',
      maxWidth: '100%',
    },
    '@media screen and (max-width: 768px)': {
      marginRight: 0,
    },
  },
  label: {
    display: 'flex',
    color: theme.colors.regentGray,
    lineHeight: '20px',
    width: 'max-content',
    fontWeight: '400',
  },
  clearButton: {
    display: 'flex',
    alignItems: 'end',
    marginBottom: '10px',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: '800',
    marginLeft: '10px',
  },
  sortWrapper: {
    marginLeft: '42px',
    display: 'flex',
    alignItems: 'end',
    '& .MuiIconButton-root': {
      padding: '8px',
    },
    '@media screen and (max-width: 768px)': {
      width: '56%',
      gap: '11px',
      marginLeft: '0px',
    },
  },

  eddmSortWrapper: {
    marginLeft: '6px',
  },

  rotate: {
    transform: 'rotate(180deg)',
  },
}

export default style
